import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel } from './data.model';

export interface IProdutoReferencia {
    id?:string,
    codigo?: string;
    nome?: string;
    estoque?: number;
}

export class ProdutoReferencia{
   idProduto:string;
   dbModel : DataModel<IProdutoReferencia>;
   constructor(private db:AngularFirestore){
     this.dbModel = new DataModel(this.db,"produtos"); 
   }
   private newQuery(idProd){
      return this.db.collection( this.dbModel.tableNameFull   ).doc(idProd)
      .collection("referencia");
   }
   getRefers(idProd, pSubscribe){
       this.idProduto = idProd;
       let q = this.newQuery(idProd).ref;
       this.dbModel.openQuery(q,pSubscribe);    
   }
   updateOrInsert(id,item){
       let old =id;
       item.id = item.codigo;
       const q = this.newQuery(this.idProduto);
       q.doc(item.id).set(item,{merge:true});
   }
   delete(idRefer){
    this.db.collection( this.dbModel.tableNameFull   ).doc(this.idProduto)
      .collection("referencia").doc(idRefer).delete();
    
   }
   
}
